// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__2QErN","caption":"Popover_caption__Pjshd","burger":"Popover_burger__9jNm7","soon":"Popover_soon__7ock_","footer":"Popover_footer__dtyeY"};